/* This file is generated by scripts/generate-build-meta.js. */
export const GENERATED_BUILD_META = Object.freeze({
  "version": "1.6.22",
  "buildId": "20260814-1832-165c6f8",
  "builtAt": "2026-08-14T13:02:29.085Z"
});
